import { render, staticRenderFns } from "./checkWeChat.vue?vue&type=template&id=286c3737&scoped=true&"
import script from "./checkWeChat.vue?vue&type=script&lang=js&"
export * from "./checkWeChat.vue?vue&type=script&lang=js&"
import style0 from "./checkWeChat.vue?vue&type=style&index=0&id=286c3737&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286c3737",
  null
  
)

export default component.exports